/*
  Play slide videos only while they are on screen.

  WHY. The home page renders four mp4 slides. Every one of them was marked
  autoplay with preload="auto", so the browser began downloading and decoding
  all four the moment the page loaded, including the two in a section below the
  fold that nobody had scrolled to yet. Measured 2026-09-25: all four sat at
  networkState 2 (loading) and readyState 0 (nothing playable) at the same time,
  competing with each other and with the images for bandwidth and for the main
  thread. That is what made scrolling feel choppy.

  Now the markup ships preload="metadata" and no autoplay attribute, and this
  starts a video when it comes into view and pauses it when it leaves.

  Degrades safely: if IntersectionObserver is missing, every video is simply
  played, which is the old behaviour.
*/
(function () {
  var SELECTOR = 'video[data-inview-play]';

  function playAll() {
    var vids = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < vids.length; i++) {
      var p = vids[i].play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  if (!('IntersectionObserver' in window)) {
    document.addEventListener('DOMContentLoaded', playAll);
    return;
  }

  function start() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          // A paused video that has never loaded still needs the nudge.
          if (v.preload === 'metadata') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.1 });

    var vids = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < vids.length; i++) observer.observe(vids[i]);

    // Sections can be re-rendered by the theme editor, so pick up new ones.
    document.addEventListener('shopify:section:load', function (e) {
      var added = e.target.querySelectorAll ? e.target.querySelectorAll(SELECTOR) : [];
      for (var j = 0; j < added.length; j++) observer.observe(added[j]);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/*
  The hero stacks its slides on top of each other, so they are all "in view" as
  far as IntersectionObserver is concerned. The slideshow marks the visible one
  with .is-active, so that class is the honest signal for which video should be
  running.
*/
(function () {
  function sync(root) {
    var vids = (root || document).querySelectorAll('video[data-slide-video]');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      var slide = v.closest ? v.closest('.rs-slide') : null;
      var active = slide ? slide.classList.contains('is-active') : true;
      if (active) {
        if (v.preload === 'none') v.preload = 'auto';
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (!v.paused) {
        v.pause();
      }
    }
  }

  function start() {
    sync(document);
    var slides = document.querySelectorAll('.rs-slide');
    if (!slides.length || !('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) sync(records[i].target.parentNode || document);
    });
    for (var j = 0; j < slides.length; j++) {
      mo.observe(slides[j], { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
